import React, { Component } from 'react'
import '../styles/css/MusicPlayer.css'

export default class MusicPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			duration: null
		}
  	};
	
	handlePlay() {
		this.audio.play();
	}
	
	handleStop() {
		this.audio.currentTime = 0;
		this.slider.value = 0;
		this.audio.pause();
	}
	
	componentDidMount() {
		this.slider.value = 0;
		this.currentTimeInterval = null;
		
		this.slider.addEventListener("click", this.seek);
		
		// Get duration of the song and set it as max slider value
		this.audio.onloadedmetadata = function() {
			this.setState({duration: this.audio.duration});
		}.bind(this);
		
		// Sync slider position with song current time
		this.audio.onplay = () => {
			this.currentTimeInterval = setInterval( () => {
				this.slider.value = this.audio.currentTime;
			}, 500);
		};
		
		this.audio.onpause = () => {
			clearInterval(this.currentTimeInterval);
		};
		
	}

	seek = e => {
		var percent = e.offsetX / e.path[0].offsetWidth
		this.audio.currentTime = percent * this.audio.duration
	}

	render() {
		const { file, onEnded } = this.props
		return (
			<div>
				<audio ref={(audio) => { this.audio = audio }} onEnded={onEnded} src={file} autoPlay={true} />
				<progress id="seek-obj" ref={(slider) => {this.slider = slider}} value="0" max={this.state.duration}></progress>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/MusicPlayer.js